




























































// Vue
import { Component, Vue } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'

// services
import { WorkDescriptionService } from '@/services/config'

// Models
import { Paginator } from '@/models'
import { WorkDescriptionModel } from '@/models/config'

@Component({
    name: 'TableListWorkDescriptions',
    components: {
        DataTable,
        IsActive
    }
})
export default class TableListWorkDescriptions extends Vue {
    loading = false
    items: WorkDescriptionModel[] | [] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'name',
            sortable: true,
            label: 'Descripción'
        },
        {
            key: 'price',
            sortable: true,
            label: 'Tarifa'
        },
        {
            key: 'is_group_piecework',
            sortable: true,
            label: 'Destajo Grupal',
            formatter: (value: string) => {
                return value ? 'SI' : 'NO'
            }
        },
        {
            key: 'status_text',
            sortable: true,
            label: 'Status'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '10%'
            }
        }
    ]

    created () {
        this.getWorkDescriptionsWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getWorkDescriptionsWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getWorkDescriptionsWithPagination()
    }

    async getWorkDescriptionsWithPagination () {
        this.loading = true
        const response = await WorkDescriptionService.getWithPagination(this.pagination.perPage, this.pagination.currentPage)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }
}
